import { loadItem } from '../utilities/localStorage';

export const STORAGE_KEY = 'OPTIONS';

// Initial State
const storage = loadItem(STORAGE_KEY);
export const initialState = {
  loading: false,
  optionsOpen: false,
  formatting: storage ? storage.formatting : 'standard',
  polling: storage ? storage.polling : 15,
  sort: storage ? storage.sort : 'skill',
};

// Action Types
export const types = {
  UPDATE_OPTIONS: 'APP/UPDATE_OPTIONS',
  UPDATE_OPTIONS_SUCCESS: 'APP/UPDATE_OPTIONS_SUCCESS',
  TOGGLE_OPTIONS: 'APP/TOGGLE_OPTIONS',
  DATA_LOADING: 'APP/DATA_LOADING',
  DATA_LOADING_FINISH: 'APP/DATA_LOADING_FINISH',
};

// Actions
export const actions = {
  toggleOptions: () => ({ type: types.TOGGLE_OPTIONS }),
  updateOptions: options => ({ type: types.UPDATE_OPTIONS, payload: { ...options } }),
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case types.DATA_LOADING:
      return { ...state, loading: true };
    case types.DATA_LOADING_FINISH:
      return { ...state, loading: false };
    case types.TOGGLE_OPTIONS:
      return { ...state, optionsOpen: !state.optionsOpen };
    case types.UPDATE_OPTIONS_SUCCESS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js